<template>
  <Card variant="outline-secondary" :size="size" class="user-card">
    <View :gap="size === 'medium' ? 'md' : 'sm'">
      <Avatar :class="{ 'medium-size-avatar': size === 'medium' }" :user-name="user.name!" />
      <View direction="column" justify="center">
        <Text :variant="labelFontsVariant">
          {{ user.name }}
        </Text>
        <div class="contact-info">
          <Text :variant="bodyFontsVariant" as="span" color="secondary">
            {{ user.email }}
          </Text>
          <span v-if="user.email && user.phoneNumber">∙</span>
          <Text :variant="bodyFontsVariant" as="span" color="secondary">
            {{ user.phoneNumber }}
          </Text>
        </div>
      </View>
    </View>
  </Card>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Card, Text, Avatar, View } from '@tallo/design-system';

import { UserDto } from '../user.interface';

const props = withDefaults(
  defineProps<{
    user: Omit<UserDto, 'id'>;
    size: 'medium' | 'small';
  }>(),
  {
    size: 'medium',
  },
);

const labelFontsVariant = computed(() => (props.size === 'medium' ? 'label-medium' : 'label-small'));
const bodyFontsVariant = computed(() => (props.size === 'medium' ? 'body-medium' : 'body-small'));
</script>

<style scoped lang="scss">
.user-card {
  width: 100%;
}

.medium-size-avatar {
  $avatar-size: 3rem;
  width: $avatar-size;
  height: $avatar-size;
  font: var(--t-typography-label-lg-font);
}

.contact-info {
  line-height: var(--t-line-height-400);
}
</style>
